/**
 * Estado operacional real de uma conexão WhatsApp (UAZAPI).
 * A linha local pode continuar "active" mesmo depois do provedor derrubar a sessão,
 * então o estado da conexão é a fonte de verdade para "está apto a enviar?".
 */

/** Estados estáveis em que a sessão não envia mensagens. "connecting" é transitório (reconexão/QR). */
export const OFFLINE_CONNECTION_STATES = new Set([
  "disconnected",
  "close",
  "closed",
  "logged_out",
  "loggedout",
]);

export interface ConnectionStateRow {
  status?: string | null;
  config?: unknown;
}

export function getConnectionState(row: ConnectionStateRow | null | undefined): string {
  const config = (row?.config ?? {}) as Record<string, unknown>;
  return String(config.connection_state ?? "").toLowerCase();
}

/** true quando a conexão não pode enviar mensagens agora. */
export function isIntegrationOffline(row: ConnectionStateRow | null | undefined): boolean {
  if (!row) return true;
  if (row.status !== "active") return true;
  return OFFLINE_CONNECTION_STATES.has(getConnectionState(row));
}
